/**
 *  Search form autocomplete
 *
 *  Заменить на свою реализацию
 */
interface SearchSuggestion{
    data: string,
    value: string,
    view: string
}
interface SearchSuggestionAnswer {
    status: string,
    warning: string,
    error: string,
    total: number,
    suggestions: SearchSuggestion[]
}

document.addEventListener("DOMContentLoaded", () => {
    const searchInput = document.querySelector<HTMLInputElement>(".search__input");
    const autocompleteBox = document.getElementById("searchAutocomplete");

    if (!searchInput || !autocompleteBox) return;

    let debounceTimer: number;
    let abortController: AbortController | null = null;

    searchInput.addEventListener("input", () => {
        const query = searchInput.value.trim();

        if (query.length < 3) {
            autocompleteBox.style.display = "none";
            return;
        }

        // Очищаем предыдущий таймер
        clearTimeout(debounceTimer);

        // Устанавливаем задержку перед отправкой запроса
        debounceTimer = window.setTimeout(() => {
            fetchSuggestions(query);
        }, 300);
    });

    searchInput.addEventListener("focus", () => {
        const query = searchInput.value.trim();
        if (query.length === 0) {
            return;
        }
        if (autocompleteBox.innerHTML !== '') {
            autocompleteBox.style.display = 'block'
        }
    });
    async function fetchSuggestions(query: string): Promise<void> {
        // Отменяем предыдущий запрос, если пользователь продолжает ввод
        if (abortController) {
            abortController.abort();
        }
        abortController = new AbortController();

        try {
            const response = await fetch(`/search/auto?c=0&query=${encodeURIComponent(query)}`, {
                signal: abortController.signal,
            });

            if (!response.ok) {
                throw new Error("Ошибка при получении данных");
            }

            const answer: SearchSuggestionAnswer = await response.json() 
            const suggestions = answer.suggestions
            updateAutocomplete(suggestions);
        } catch (error) {
                console.log(error);
                
            if (error instanceof Error && error.name !== "AbortError") {
                console.error("Ошибка загрузки подсказок:", error);
            }
        }
    }

    function updateAutocomplete(suggestions: SearchSuggestion[]): void {
        if (!autocompleteBox) {
            return
        }
        if (!suggestions.length) {
            autocompleteBox.style.display = "none";
            return;
        }

        autocompleteBox.innerHTML = suggestions
            .map(item => item.view)
            .join("");

        autocompleteBox.style.display = "block";
    }

    document.addEventListener("click", (event: MouseEvent) => {
        if (!searchInput.contains(event.target as Node) && !autocompleteBox.contains(event.target as Node)) {
            autocompleteBox.style.display = "none";
        }
    });
    
    document.addEventListener("keydown", (e: KeyboardEvent) => {
        if (e.key === "Escape") {
            autocompleteBox.style.display = "none";
        }
    });
});
